import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/assistant.png'


const _hoisted_1 = { class: "relative z-50" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-500 material-icons-outlined" }, " tips_and_updates ", -1)
const _hoisted_3 = {
  key: 0,
  style: {"width":"500px","max-height":"400px","overflow":"auto","z-index":"1000"},
  class: "card shadow-elevation bg-white absolute bottom-0 left-0 transform translate-y-full -translate-x-full z-50"
}
const _hoisted_4 = { class: "flex flex-col space-y-2 z-50" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center space-x-2" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "flex rounded-full p-1.5",
    style: {"background":"#e8d6fb"}
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "w-5 h-auto"
    })
  ]),
  /*#__PURE__*/_createElementVNode("strong", { class: "text-primary" }, "Evo Assistant")
], -1)
const _hoisted_6 = {
  key: 1,
  class: "flex flex-col space-y-2 mb-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-72 rounded-lg skeleton-unit" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-92 rounded-lg skeleton-unit" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-92 rounded-lg skeleton-unit" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-72 rounded-lg skeleton-unit" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-92 rounded-lg skeleton-unit" }, null, -1)
const _hoisted_12 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]

import { computed, PropType, ref } from "vue";
import Btn from "../ui/Btn.vue";
import axios from "axios";
import ProcessedTextFragment from "../ui/ProcessedTextFragment.vue";
import { useRouter } from "vue-router";
import { useMainStore } from "../../stores/mainStore";
import { useMetaStore } from "../../stores/metaStore";
import { EventParticipationSlotSubmission, getEmptySubmission } from "../../models";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExerciseHintButton',
  props: {
	exerciseId: {
		type: String,
		required: true,
	},
	submission: {
		type: Object as PropType<EventParticipationSlotSubmission>,
		default: getEmptySubmission,
	},
},
  setup(__props) {

const props = __props;



const mainStore = useMainStore();
const router = useRouter();

const currentCourse = computed(
	() =>
		mainStore.getCourseById(router.currentRoute.value.params.courseId as any as string)!,
);

const loading = ref(false);
const hintMessage = ref("");
const showHintMessage = ref(false);

const onAskForHint = async () => {
	if (hintMessage.value.length > 0) {
		showHintMessage.value = !showHintMessage.value;
		return;
	}

	loading.value = true;
	try {
		setTimeout(() => {
			showHintMessage.value = true;
		}, Math.floor(Math.random() * 2500) + 2500);
		const response = await axios.post(
			`/courses/${currentCourse.value.id}/assistant-conversations/ask_for_hint/`,
			{
				exercise_id: props.exerciseId,
				answer_text: props.submission.answer_text,
			},
		);
		hintMessage.value = response.data;
		// hintMessage.value =
		// 	'Per affrontare l\'esercizio "Ogni studente passa il test solo se ha studiato abbastanza", ti consiglio di considerare prima la struttura logica della frase. \n\nL\'affermazione "Ogni studente passa il test solo se ha studiato abbastanza" può essere vista come un\'implicazione tra due proposizioni. Pensa a come rappresentare la frase in termini di predicati. \n\nIn particolare, rifletti su come tradurre la parte "passa il test" e "ha studiato abbastanza" in termini di implicazione. Ricorda che l\'uso di "solo se" è cruciale: indica che il primo predicato implica il secondo. Quindi, potresti iniziare a scrivere una formula che rispetti questa implicazione.\n\nChe ne dici di provare a esercitarti su questi argomenti?';
		showHintMessage.value = true;

		// trigger tex rendering
		useMetaStore().dirtyTex = true;
	} finally {
		loading.value = false;
	}
};

const onCloseHintMessage = () => {
	console.log("onCloseHintMessage", showHintMessage.value);
	showHintMessage.value = false;
};

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Btn, {
      tooltip: 'Chiedi un suggerimento',
      loading: loading.value,
      class: "",
      variant: 'icon',
      outline: true,
      onClick: onAskForHint
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showHintMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                (hintMessage.value)
                  ? (_openBlock(), _createBlock(ProcessedTextFragment, {
                      key: 0,
                      value: hintMessage.value,
                      class: "bg-gray-50 p-2 rounded-lg"
                    }, null, 8, ["value"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_12))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ])), [
    [_directive_click_outside, onCloseHintMessage]
  ])
}
}

})